module.exports = __webpack_public_path__ + "img/icons-fill-timesheets-sapphire.88d9203d.svg";